import { GrowAccountOverview, GrowFund, GrowIncomeProjection, GrowPortfolioAllocation, GrowTotalNetIncome } from '@inyova/grow';
import { GrowAccount, LoadState } from '@inyova/models';

export enum GrowProjectsFilters {
  ALL,
  NEW,
  MY_PROJECTS,
  INVESTABLE,
  RUNNING
}

export interface GrowPerformanceVm {
  growAccount: GrowAccount;
  portfolioAllocation: GrowPortfolioAllocation;
  hasInvestedFund: boolean;
  fund: GrowFund;
  overviewLoadState: LoadState;
  overview: GrowAccountOverview;
  incomeProjectionLoadState: LoadState;
  incomeProjection: GrowIncomeProjection;
  projectsActiveFilter: GrowProjectsFilters;
  totalNetIncome: GrowTotalNetIncome;
}
